export default "https://a.travel-assets.com/partner-portal/skewed_box.7ef0dde6bb86.svg";